import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { variables } from '@indriver/yrel';
import React__default from 'react';
import { StyledTextForHeading } from './heading.styles.js';

var _excluded = ["color", "type", "margin", "size", "fontType"];
var HeadingMap = {
  h1: 'xl',
  h2: 'l',
  h3: 'm',
  h4: 's'
};
var Heading = function Heading(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? variables['text-and-icon-primary'] : _ref$color,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'h1' : _ref$type,
      margin = _ref.margin,
      size = _ref.size,
      _ref$fontType = _ref.fontType,
      fontType = _ref$fontType === void 0 ? 'default' : _ref$fontType,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  var computedSize = size != null ? size : HeadingMap[type];
  return /*#__PURE__*/React__default.createElement(StyledTextForHeading, _extends({
    size: computedSize,
    margin: margin,
    fontType: fontType,
    color: color
  }, props, {
    as: type
  }));
};

export { Heading };
